/* D/R ARCHIVE redesign (draft theme only): drawers + model bar. Safe to include more than once. */
(function () {
  if (window.DrRedesign) return;
  var openDrawer = null;
  var lastOpener = null;

  function lock(on) {
    document.documentElement.classList.toggle('dr-scroll-lock', on);
  }

  function setOpen(drawer, open, opener) {
    if (!drawer) return;
    var panel = drawer.querySelector('.dr-drawer__panel');
    if (open) {
      if (openDrawer && openDrawer !== drawer) setOpen(openDrawer, false);
      lastOpener = opener || null;
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      if (lastOpener) lastOpener.setAttribute('aria-expanded', 'true');
      lock(true);
      openDrawer = drawer;
      if (panel) panel.focus({ preventScroll: true });
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      if (lastOpener) {
        lastOpener.setAttribute('aria-expanded', 'false');
        lastOpener.focus({ preventScroll: true });
      }
      lock(false);
      if (openDrawer === drawer) openDrawer = null;
    }
  }

  function initDrawers(root) {
    (root || document).querySelectorAll('[data-dr-drawer]').forEach(function (drawer) {
      if (drawer.dataset.drInit) return;
      drawer.dataset.drInit = '1';
      /* portal to <body>: escapes transformed / z-indexed ancestors (theme header, section animations) */
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      /* t80: a drawer opened by the inline pre-JS fallback stays open and becomes the tracked drawer */
      if (drawer.classList.contains('is-open')) { openDrawer = drawer; lastOpener = document.querySelector('[data-dr-drawer-open="' + drawer.id + '"]'); } else { drawer.setAttribute('inert', ''); }
      drawer.querySelectorAll('[data-dr-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          setOpen(drawer, false);
        });
      });
      /* backdrop / outside tap: any click on the drawer root outside the panel closes it */
      drawer.addEventListener('click', function (e) {
        var panel = drawer.querySelector('.dr-drawer__panel');
        if (drawer.classList.contains('is-open') && panel && !panel.contains(e.target)) setOpen(drawer, false);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dr-drawer-open]');
    if (!opener) return;
    e.preventDefault();
    setOpen(document.getElementById(opener.getAttribute('data-dr-drawer-open')), true, opener);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) setOpen(openDrawer, false);
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
    if (mq.matches && openDrawer) setOpen(openDrawer, false);
  });

  function initModelBars(root) {
    (root || document).querySelectorAll('[data-dr-modelbar]').forEach(function (bar) {
      if (bar.dataset.drInit) return;
      bar.dataset.drInit = '1';
      var list = bar.querySelector('.dr-modelbar__list');
      if (!list) return;
      var active = list.querySelector('[aria-current="page"]');
      if (active && list.scrollWidth > list.clientWidth) {
        list.scrollLeft = Math.max(0, active.parentElement.offsetLeft - 16);
      }
      function update() {
        var overflowing = list.scrollWidth > list.clientWidth + 2;
        bar.classList.toggle('is-overflowing', overflowing);
        bar.classList.toggle('no-overflow', !overflowing);
        bar.classList.toggle('is-at-end', overflowing && list.scrollLeft + list.clientWidth >= list.scrollWidth - 4);
      }
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
      update();
    });
  }

  // Keep --header-height in sync with the (sticky, compacting) header; smooth in-page anchors.
  function initHeaderAnchors() {
    var hs = document.querySelector('.section-header');
    if (hs && 'ResizeObserver' in window && !hs._drRO) {
      hs._drRO = new ResizeObserver(function () { document.documentElement.style.setProperty('--header-height', hs.offsetHeight + 'px'); });
      hs._drRO.observe(hs);
    }
    if (hs && document.querySelector('#MainContent[data-template="index"]') && !hs._drFix) {
      hs._drFix = true;
      var threshold = 0, ticking = 0;
      var measure = function () {
        var was = hs.classList.contains('dr-hdr-fixed');
        hs.classList.remove('dr-hdr-fixed');
        threshold = Math.max(0, hs.getBoundingClientRect().top + window.pageYOffset);
        if (was) hs.classList.add('dr-hdr-fixed');
        apply();
      };
      var apply = function () { ticking = 0; hs.classList.toggle('dr-hdr-fixed', window.pageYOffset > 0 && window.pageYOffset >= threshold); };
      window.addEventListener('scroll', function () { if (!ticking) ticking = requestAnimationFrame(apply); }, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      measure();
    }
    if (document._drAnchors) return; document._drAnchors = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
      if (u.origin !== location.origin || u.pathname !== location.pathname || u.search !== location.search || u.hash.length < 2) return;
      var t = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.pushState) history.pushState(null, '', u.hash);
    });
  }

  // Buttons that follow the header menu's link mapping (e.g. ARCHIVE SELECT → ARCHIVE DEALS).
  function initSyncLinks() {
    document.querySelectorAll('[data-dr-sync-handle]').forEach(function (a) {
      var h = a.getAttribute('data-dr-sync-handle'); if (!h) return;
      var src = Array.prototype.find.call(document.querySelectorAll('#DrHeaderNav a[href], .dr-drawer--menu a[href]'), function (l) {
        var u = l.getAttribute('href'); return u.indexOf('/pages/' + h) === 0 || u.indexOf('q=' + h + '&') > -1 || /\/pages\//.test(u) && u.split('?')[0].split('/').pop() === h;
      });
      if (src) a.setAttribute('href', src.getAttribute('href'));
    });
  }

  function init() {
    initSyncLinks();
    initDrawers();
    initModelBars();
    initHeaderAnchors();
  }

  window.DrRedesign = { init: init, setOpen: setOpen };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
